export default "__VITE_ASSET__3f818f36__"